module.exports = __webpack_public_path__ + "img/jishu.a0b9a00c.svg";